import { render, staticRenderFns } from "./ProfileIdentNetVolunteerForm.vue?vue&type=template&id=1a1529ab"
import script from "./ProfileIdentNetVolunteerForm.vue?vue&type=script&lang=ts"
export * from "./ProfileIdentNetVolunteerForm.vue?vue&type=script&lang=ts"
import style0 from "./ProfileIdentNetVolunteerForm.vue?vue&type=style&index=0&id=1a1529ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports